// const API_BASE_URL = "http://localhost:8000/api";

const API_BASE_URL = "https://demo.lifeit.in/api";

export default API_BASE_URL;